export default __webpack_public_path__ + "static/board1-e9e27fd71676393cabda1120213e00d7.png";